// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer__1C46t","right":"index_right__1zbed"};